import { combineReducers } from '@reduxjs/toolkit'

import nurseReducer from './nurse-health-condition'
import nurseVisitReducer from './nurse-visit'
import nurseReportReducer from './nurse-report'

const combinedReducer = combineReducers({
  healthCondition: nurseReducer,
  nurseVisit: nurseVisitReducer,
  report: nurseReportReducer,
})

export default combinedReducer
